import React from 'react';
import { tie } from '../page/typography';

/**
 * Шкала ключових дат статті.
 *
 * До md вертикальна, від md горизонтальна: у чотири колонки на вужчому
 * екрані дата й підпис рвалися б на слова. Дата, що має `deadline`, —
 * жовта: саме її людина шукає очима.
 *
 * `labelledBy` — id підпису над шкалою; підпис кожне місце ставить своє.
 */
const KeyDates = ({ dates = [], labelledBy, className = '' }) => (
  <ol aria-labelledby={labelledBy} className={`list-none m-0 p-0 grid gap-5 md:grid-cols-4 md:gap-4 ${className}`}>
    {dates.map((d, i) => {
      const last = i === dates.length - 1;
      return (
        <li key={d.date} className="relative pl-6 md:pl-0 md:pt-6">
          {!last && (
            <span
              className="absolute left-[5px] top-[1.1rem] -bottom-5 w-px bg-teal-200 md:left-[11px] md:top-[5px] md:-right-4 md:bottom-auto md:w-auto md:h-px"
              aria-hidden="true"
            ></span>
          )}
          <span
            className={`absolute left-0 top-[0.4rem] md:top-0 w-[11px] h-[11px] rounded-full border-2 ${
              d.deadline ? 'border-amber-500 bg-amber-400' : 'border-teal-600 bg-white'
            }`}
            aria-hidden="true"
          ></span>
          <time
            dateTime={d.date}
            className={`block font-display font-bold leading-snug ${d.deadline ? 'text-amber-800' : 'text-slate-900'}`}
          >
            {d.label}
          </time>
          <span className={`mt-1 block text-sm leading-snug ${d.deadline ? 'text-slate-800 font-medium' : 'text-slate-600'}`}>
            {tie(d.text)}
          </span>
        </li>
      );
    })}
  </ol>
);

export default KeyDates;
